import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { useCallback, useMemo } from 'react';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { Link } from 'foundations-components/transitional/components/Link';
import { useHasDataSharingCompanyGate } from '../hooks/useHasGate';
import { useGetCompanyRelatedAccountsQuery, useIsConnectedCompanyQuery } from '../../__generated__/chirp/com/hubspot/multi/account/crm/manager/rpc/MultiAccountCrmManagerChirpService.hooks';
import { ErrorBoundary } from './ErrorBoundary';
import { useHasDataSharingCompanyReadScope } from '../hooks/useHasScope';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MultiAccountCompany({
  companyId
}) {
  var _relatedAccountsRespo;
  const openPanelMessage = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_MULTI_ACCOUNT_PANEL);
  const openPanel = useCallback((portalId, objectId) => {
    return openPanelMessage({
      portalId,
      objectId,
      objectTypeId: '0-2'
    });
  }, [openPanelMessage]);
  const {
    hasScope: hasCompanyReadScope
  } = useHasDataSharingCompanyReadScope();
  const hasCompanyGate = useHasDataSharingCompanyGate();
  const {
    loading: isConnectedCompanyLoading,
    data: isConnectedCompanyData
  } = useIsConnectedCompanyQuery({
    variables: {
      companyId
    },
    // Skip query if not ungated or invalid companyId
    skip: !hasCompanyGate || isNaN(companyId)
  });
  const isConnectedCompany = useMemo(() => (isConnectedCompanyData === null || isConnectedCompanyData === void 0 ? void 0 : isConnectedCompanyData.isConnectedCompany) || false, [isConnectedCompanyData === null || isConnectedCompanyData === void 0 ? void 0 : isConnectedCompanyData.isConnectedCompany]);
  const {
    loading: relatedAccountsLoading,
    error: relatedAccountsError,
    data: relatedAccountsResponse
  } = useGetCompanyRelatedAccountsQuery({
    variables: {
      companyId
    },
    // Skip query if not ungated, not scopes, not a connected company, or invalid companyId
    skip: !hasCompanyGate || !hasCompanyReadScope || isNaN(companyId) || isConnectedCompanyLoading || !isConnectedCompany
  });

  // Return null if any prerequisite condition fails
  if (!hasCompanyGate || isConnectedCompanyLoading || !isConnectedCompany) {
    return null;
  }
  if (hasCompanyReadScope) {
    const noRelatedData = relatedAccountsLoading || relatedAccountsError || !(relatedAccountsResponse !== null && relatedAccountsResponse !== void 0 && relatedAccountsResponse.sharedCompany) || !(relatedAccountsResponse !== null && relatedAccountsResponse !== void 0 && relatedAccountsResponse.relatedAccounts) || relatedAccountsResponse.relatedAccounts.length === 0;
    if (noRelatedData) return null;
  }
  const sharedPortalId = (relatedAccountsResponse === null || relatedAccountsResponse === void 0 || (_relatedAccountsRespo = relatedAccountsResponse.relatedAccounts) === null || _relatedAccountsRespo === void 0 || (_relatedAccountsRespo = _relatedAccountsRespo[0]) === null || _relatedAccountsRespo === void 0 ? void 0 : _relatedAccountsRespo.portalId) || 0;
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    children: [/*#__PURE__*/_jsx(StatusDot, {
      use: "success"
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "multi-account-crm-panel-lib.company_jsx",
      options: {
        onClick: () => openPanel(sharedPortalId, companyId),
        'data-test-id': 'connected-company-link'
      },
      elements: {
        Link
      }
    })]
  });
}